import { render, staticRenderFns } from "./TransferenciaPage.vue?vue&type=template&id=8d4bf856"
import script from "./TransferenciaPage.js?vue&type=script&lang=js&external"
export * from "./TransferenciaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports